import { toMentionSegments } from 'features/TeamChat/api/teamChat.transform'
import type { TeamMember } from 'features/TeamChat/api/teamChat.types'
import styles from 'features/TeamChat/teamChat.module.scss'

type Props = { text: string; members: TeamMember[] }

const SEGMENT_CLASS = { plain: undefined, mention: styles.mention, mentionMe: styles.mentionMe }

export const MentionText = ({ text, members }: Props) => (
  <>
    {toMentionSegments(text, members).map((s, i) => (
      <span key={i} className={SEGMENT_CLASS[s.kind]}>
        {s.text}
      </span>
    ))}
  </>
)
